import { StoreData } from "./store.data";
import {
  SymbolGroup,
  SymbolGroupEnum,
} from "@bitwarden/web-vault/app/models/types/symbol-group.types";

export type SymbolModelVersion = 0 | 1;

type SymbolSource = string;
type SymbolSourceCode = string;

export interface ISymbolStoreData {
  /** The name of the symbol */
  nm: string;
  /** The source codes of the symbol */
  scs: Record<SymbolSource, SymbolSourceCode>;
  /** The symbol/asset group. Absent on v0 records - callers should default it (see SymbolView.fromStoreModel). */
  grp?: SymbolGroup;
}

export interface SymbolStoreModel extends StoreData, ISymbolStoreData {
  v: SymbolModelVersion;
}

export const DefaultSymbolStoreModel: SymbolStoreModel = {
  id: "",
  dc: "",
  dm: "",
  v: 1,
  vid: "",
  nm: "",
  scs: {},
  grp: SymbolGroupEnum.other,
};
